import { useEffect, useState } from 'react';

const DOMAIN = 'mytegroup.ai';
const SCRIPT_SRC = 'https://plausible.io/js/plausible.js';

export default function CookieConsentBanner() {
  const [consent, setConsent] = useState(() => {
    try {
      return localStorage.getItem('cookieConsent');
    } catch {
      return null;
    }
  });
  const [showBanner, setShowBanner] = useState(!consent);

  // Load analytics script when consent given
  useEffect(() => {
    if (consent === 'analytics') {
      if (!document.querySelector(`script[data-domain="${DOMAIN}"]`)) {
        const script = document.createElement('script');
        script.src = SCRIPT_SRC;
        script.async = true;
        script.defer = true;
        script.setAttribute('data-domain', DOMAIN);
        document.head.appendChild(script);
      }
    }
  }, [consent]);

  const acceptAnalytics = () => {
    try {
      localStorage.setItem('cookieConsent', 'analytics');
    } catch (e) {
      // ignore write errors
    }
    setConsent('analytics');
    setShowBanner(false);
  };
  const rejectAnalytics = () => {
    try {
      localStorage.setItem('cookieConsent', 'necessary');
    } catch (e) {
      // ignore write errors
    }
    setConsent('necessary');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 bg-white text-gray-900 p-4 shadow-lg z-50 flex flex-col md:flex-row items-center justify-between">
      <div className="mb-2 md:mb-0 text-sm">
        We use cookies to enhance your experience. Select your preferences.
      </div>
      <div className="flex space-x-2">
        <button
          onClick={rejectAnalytics}
          className="px-4 py-2 bg-gray-200 rounded text-sm hover:bg-gray-300"
        >Necessary only</button>
        <button
          onClick={acceptAnalytics}
          className="px-4 py-2 bg-blue-600 text-white rounded text-sm hover:bg-blue-700"
        >Accept analytics</button>
      </div>
    </div>
  );
}